import React, { useState } from "react";
import MedicationSearch from "./MedicationSearch";
import { MedicationSearchResult } from "model/medication-search-result.model";
import { GlobalState } from "store/configure-store";
import { selectPatient } from "store/reducers/patient.reducer";
import { selectUser } from "store/reducers/user-context.reducer";
import { connect, useDispatch } from "react-redux";
import { PV_MEDICATION_SEARCH } from "common/matomo/track-page-view.constants";
import { useTrackPageView } from "common/matomo/track-page-view.hook";
import { medicationSearchPromise } from "store/medication/medication.types";

export interface Props {
  onSelectMedication: (medication: MedicationSearchResult) => void;
}

const MedicationSearchContainer = ({
  onSelectMedication,
}: Props & StateFromProps) => {
  const dispatch = useDispatch();
  const [searchResults, setSearchResults] = useState<MedicationSearchResult[]>(
    []
  );
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);

  useTrackPageView(PV_MEDICATION_SEARCH);

  const handleSearchMedication = (searchText: string) => {
    setSearchKey(searchText);
    if (searchText && searchText.length > 2) {
      setLoading(true);
      dispatch(medicationSearchPromise(searchText))
        .then((medicationSearchResults: MedicationSearchResult[]) => {
          setSearchResults(medicationSearchResults);
        })
        .finally(() => setLoading(false));
    } else {
      setSearchResults([]);
    }
  };

  return (
    <MedicationSearch
      searchKey={searchKey}
      searchResults={searchResults}
      loading={loading}
      onSelectMedication={onSelectMedication}
      onSearchMedication={handleSearchMedication}
    />
  );
};

interface StateFromProps {
  patientId: number;
  caregiverId: number;
}

const mapStateToProps = (state: GlobalState) => {
  return {
    patientId: selectPatient(state).id,
    caregiverId: selectUser(state).id,
  };
};

export default connect(mapStateToProps)(MedicationSearchContainer);
